import { Component, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BaseModalComponent } from '../../modal/_base-modal.component';
import { LoaderComponent } from '../../loader/loader.component';
import { ProfilePasswordFormComponent } from '../profile-password-form/profile-password-form.component';

import { ProfileInfoService } from '../profile-info.service';


@Component({
  moduleId: module.id,
  selector: 'profile-reset-password-modal',
  templateUrl: 'profile-reset-password-modal.component.html',
  styleUrls: ['profile-reset-password-modal.component.scss'],
})
export class ProfileResetPasswordModalComponent extends BaseModalComponent {

  @ViewChild('loaderResetPassword', {static: false}) loader: LoaderComponent | void;
  @ViewChild('profileForm', {static: false}) profileForm: ProfilePasswordFormComponent | void;

  constructor(
    private profileInfoService: ProfileInfoService,
  ) {
    super();
  }

  get form() {
    return this.profileForm ? this.profileForm.form : null;
  }

  // handlers
  onChangePasswordClick() {
    if (!this.form || this.form.invalid) { return; }
    if (this.loader instanceof LoaderComponent) {
      this.loader.show();
    }
    const value = this.form.value;
    this.profileInfoService.userResetPassword(value.currentPassword, value.newPassword, value.newPasswordConfirm)
    .subscribe((res: any) => {

      if (this.loader instanceof LoaderComponent) {
        this.loader.hide();
      }
      if (res.status === false) {
        if (this.profileForm instanceof ProfilePasswordFormComponent) {
          this.profileForm.setCurrentPasswordNotMatchError();
        }
      } else {
        if (this.profileForm instanceof ProfilePasswordFormComponent) {
          this.profileForm.clearCurrentPasswordErrors();
        }
        this.hide();
      }
    });
  }
}
